import { useTranslation } from 'next-i18next'

import ArrowRight from '@/public/icons/ArrowRight.svg'
import Image from 'next/image'
export default function ForgotPassword() {
  const { t } = useTranslation('password-generator')
  return (
    <section className="py-12 lg:py-24">
      <div className="max-w-[1280px] xl:px-0 px-5 mx-auto space-y-12">
        <h2 className="text-display-lg font-semibold text-heading text-center">
          Bạn đã từng gặp sự cố vì quên mật khẩu?
        </h2>
        <p className="text-lg text-heading-desctiption text-center max-w-[730px] mx-auto">
          Với trình quản lý mật khẩu Locker, bạn sẽ không bao giờ quên mật khẩu thêm một lần nào
          nữa. Lưu và tự động điền mật khẩu với mọi trang web dễ dàng và bảo mật.
        </p>
        <div className="grid md:grid-cols-2 gap-8 max-w-[1052px] mx-auto">
          <div className="border border-solid border-gray-50 rounded-xl pl-14 pt-8 text-center bg-gray-50 flex flex-col items-end justify-between">
            <div className="pr-14">
              <h4 className="lg:text-display-xs text-xl text-heading font-semibold">
                Giải phóng trí nhớ của bạn
              </h4>
              <p className="text-md text-gray-700">
                Sử dụng tiện ích mở rộng trình duyệt hoặc ứng dụng Locker trên di động để tạo mật
                khẩu mạnh, lưu mật khẩu vào kho dữ liệu an toàn của bạn.
              </p>
              <a
                href={
                  process.env.NEXT_PUBLIC_EXTENSION_LINK ||
                  'https://chromewebstore.google.com/detail/locker-password-manager/cmajindocfndlkpkjnmjpjoilibjgmgh'
                }
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 justify-center font-semibold text-md text-primary mt-6"
              >
                <span>Cài đặt tiện ích mở rộng trình duyệt</span>
                <ArrowRight className="w-6 h-6 " />
              </a>
            </div>
            <Image
              className="max-w-full object-contain"
              src="/images/password-generator/Memmory.png"
              width={400}
              height={500}
              alt="Locker Pasword Generator"
            />
          </div>
          <div className="border border-solid border-gray-50 rounded-xl pl-14 pt-8 text-center bg-gray-50 flex flex-col items-end justify-between">
            <div className="pr-14">
              <h4 className="lg:text-display-xs text-xl text-heading font-semibold">
                Locker bên bạn tới bất kỳ đâu
              </h4>
              <p className="text-md text-gray-700">
                Dù bạn làm việc trên máy tính, hay giải trí trên smartphone. Dù bạn lướt web trực
                tuyến, hay đang trong chuyến đi dã ngoại. Bạn luôn có thể truy cập vào mật khẩu của
                mình được lưu trữ an toàn trong ứng dụng Locker.
              </p>
              <a
                href={
                  process.env.NEXT_PUBLIC_IOS_LINK ||
                  'https://apps.apple.com/us/app/locker-password-manager/id1586927301'
                }
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 justify-center font-semibold text-md text-primary mt-6"
              >
                <span>Tải ứng dụng Locker trên iOS</span>
                <ArrowRight className="w-6 h-6 " />
              </a>
              <a
                href={
                  process.env.NEXT_PUBLIC_ANDROID_LINK ||
                  'https://play.google.com/store/apps/details?id=com.cystack.locker&pli=1'
                }
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 justify-center font-semibold text-md text-primary mt-1"
              >
                <span>Tải ứng dụng Locker trên Android</span>
                <ArrowRight className="w-6 h-6 " />
              </a>
            </div>
            <Image
              width={450}
              height={250}
              className="max-w-full max-h-full"
              src="/images/password-generator/Mobile.png"
              alt="Locker Pasword Generator"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
